import classnames from "classnames";
import twMerge from "@krea/customer-features/utils/tailwind-utils";
import { Helper } from "@krea/customer-features/shared-components/helper";
import { Text } from "@krea/customer-features/shared-components/text";

interface IBidDetailsItem {
  title: string;
  value: string | number | null;
  className?: string;
  total?: boolean;
  tooltip?: string | null;
}

const BidDetailsItem = ({
  title,
  value,
  className,
  total,
  tooltip,
}: IBidDetailsItem) => {
  return (
    <dl
      className={twMerge(
        "tw-p-0 tw-m-0 tw-my-[16px] tw-overflow-hidden",
        {
          "tw-pt-4 tw-border-t tw-border-[#ebe8ef]": total,
        },
        className,
      )}
    >
      <Text htmlTag="dt" size="sm" className="tw-text-gray-600 tw-font-normal">
        {title}
      </Text>
      <Text
        htmlTag="dd"
        size={total ? "lg" : "md"}
        className="tw-m-0 tw-text-dark tw-font-bold"
      >
        <span className={classnames({ "tw-mr-1 tw-align-middle": tooltip })}>
          {value}
        </span>
        {tooltip && <Helper content={tooltip} className="tw-align-middle" />}
      </Text>
    </dl>
  );
};

export default BidDetailsItem;
